<template>
  <div class="opt-record">
    <el-card :body-style="{ padding: '20px' }">
      <div class="global-body-wrap">
        <el-table :data="tableData" :expand-row-keys="expandRowKeys" row-key="_id" :row-class-name="getRowClass"
          @row-click="handleRowClick" border size="small">
          <el-table-column type="expand">
            <template slot-scope="props">
              <div class="p-2" style="width: 99%; margin: 0 auto">
                <el-table :data="props.row.diff" size="small" border>
                  <el-table-column prop="key" label="字段" width="120"></el-table-column>
                  <el-table-column prop="before" label="变更前" :formatter="formatDiffValue"></el-table-column>
                  <el-table-column prop="after" label="变更后" :formatter="formatDiffValue"></el-table-column>
                </el-table>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="user" label="操作人" :formatter="formatUser"></el-table-column>
          <el-table-column prop="operation" label="操作" :formatter="formatOperation"></el-table-column>
          <el-table-column prop="createdAt" label="操作时间" :formatter="formatDateTime"></el-table-column>
        </el-table>
      </div>
      <pagination :pageSize="params.pageSize" :total="total" @pageNum="getPageNum" />
    </el-card>
  </div>
</template>

<script>
import pagination from "@/components/pagination";
import api from "@/api";

export default {
  name: "OptRecord",
  components: {
    pagination
  },
  props: {
    detailId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      params: {
        page: 1,
        pageSize: 20
      },
      tableData: [],
      total: 0,
      expandRowKeys: []
    };
  },
  watch: {
    detailId: {
      immediate: true,
      handler() {
        if (this.detailId) {
          this.getList();
        }
      }
    }
  },
  methods: {
    getList() {
      if (!this.detailId) return;
      api
        .getMaterialPublisherOptRecord(this.detailId, this.params)
        .then((res) => {
          this.tableData = res.data.items || [];
          this.total = res.data.count || 0;
        })
        .catch((err) => {
          this.$message.error(err.message || "获取操作记录失败");
        });
    },
    getPageNum(page) {
      this.params.page = page;
      this.getList();
    },
    handleRowClick(row) {
      if (!row.diff || !row.diff.length) return;
      const index = this.expandRowKeys.indexOf(row._id);
      if (index > -1) {
        this.expandRowKeys.splice(index, 1);
      } else {
        this.expandRowKeys.push(row._id);
      }
    },
    getRowClass({ row }) {
      if (!row.diff || !row.diff.length) {
        return "row-expand-disable";
      }
      return "";
    },
    formatUser(row) {
      return row.user ? row.user.nickname : "";
    },
    formatOperation(row) {
      return row.operation === "edit" ? "更新" : "新增";
    },
    formatDateTime(row) {
      if (!row.createdAt) return "";
      const date = new Date(row.createdAt);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    formatDiffValue(row) {
      const value = row.before !== undefined ? row.before : row.after;
      if (value === null || value === undefined || value === "") return "-";

      if (row.key === "updatedAt") {
        const dateStr = String(value).replace(/^"+|"+$/g, "");
        const date = new Date(dateStr);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");
        const seconds = String(date.getSeconds()).padStart(2, "0");
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      }
      return String(value);
    }
  }
};
</script>

<style scoped>
.opt-record {
  padding: 20px;
}

:deep(.el-table .row-expand-disable .cell .el-table__expand-icon) {
  display: none;
}
</style>
